import { useState } from "react";
import { createUseStyles } from "react-jss";

import inputTextEditorReadOnlySkin from "../../../../skins/input-text-editor-read-only.skin";
import Icon from "../../icon";
import i18n from "../../../../utils/locale/i18n";

const useStyles = createUseStyles(inputTextEditorReadOnlySkin);

function stripTags(html) {
  return html.replace(/<\/?[^>]+(>|$)/g, "");
}

function trimText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

function InputTextEditorReadOnly({ value, className }) {
  const [showFormatted, setShowFormatted] = useState(false);

  const classes = useStyles();

  const toggleShowFormatted = () => {
    setShowFormatted(!showFormatted);
  };

  return (
    <div className={className}>
      {value && (
        <>
          {showFormatted ? (
            <div dangerouslySetInnerHTML={{ __html: value }} />
          ) : (
            <span>{trimText(stripTags(value), 30)}</span>
          )}
          <span
            onClick={toggleShowFormatted}
            className={classes["iconButton"]}
            title={showFormatted ? i18n.t("hide") : i18n.t("show")}
          >
            {showFormatted ? <Icon icon="eye-slash" /> : <Icon icon="eye" />}
          </span>
        </>
      )}
    </div>
  );
}

export default InputTextEditorReadOnly;
